import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * LeadDelegationService - Angular service for lead/deal delegation
 * in the Sales Team Collaboration module.
 *
 * Backend base: /api/leadDelegation  (ecom-svc-admin)
 */
@Injectable({
  providedIn: 'root'
})
export class LeadDelegationService {

  private readonly base = environment.serverAPI4 + '/api/leadDelegation';

  constructor(private http: HttpClient) {}

  /**
   * Delegate a resource to a new owner.
   * Body: DelegationRequest (resourceType, resourceId, previousOwner*, newOwner*, reason)
   */
  delegate(body: {
    resourceType: string;
    resourceId: number;
    previousOwnerId: number;
    previousOwnerName: string;
    newOwnerId: number;
    newOwnerName: string;
    newOwnerEmail?: string;
    delegatedBy: number;
    delegatedByName: string;
    reason?: string;
  }): Observable<any> {
    return this.http.post(this.base, body);
  }

  /** Get the delegation history for a resource. */
  getHistory(resourceType: string, resourceId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.base}/history/${resourceType}/${resourceId}`);
  }

  /** Get all delegation records for the tenant (paginated). */
  getAll(page = 0, size = 20): Observable<any> {
    return this.http.get(`${this.base}?page=${page}&size=${size}`);
  }
}
